import * as React from 'react';
import { useContext } from 'react';

import { UIHeading3, UIText3 } from '@cian/ui-kit';
import { trackQRShow } from './tracking';
import { PhoneLinkWrapper } from '../../components/DynamicPhoneLinkWrapper';
import { PhoneLinkQRCode } from '../../components/PhoneLinkQRCode';
import { TPlaceType } from '../../types/promoDetails/callButton';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';
import { NewbuildingDynamicPhone } from '../NewbuildingDynamicPhone';

interface IPhonesOpenedProps {
  placeType: TPlaceType;
  formattedPhone: { number: string; link: string };
}

export const PhonesOpened = ({ placeType, formattedPhone }: IPhonesOpenedProps) => {
  const { siteBlockId, builder, offerId } = useContext(PromoOfferCardContext);

  const showBuilderName = React.useMemo(() => placeType === 'promoOffer', [placeType]);

  const onQRShowHandler = React.useCallback(() => {
    trackQRShow({
      label: placeType === 'promoPopup' ? 'modal_qr_code' : 'carousel_qr_code',
      offerId,
    });
  }, [placeType, offerId]);

  if (siteBlockId) {
    return <NewbuildingDynamicPhone placeType={placeType} onQRShowHandler={onQRShowHandler} />;
  }

  return (
    <PhoneLinkWrapper
      phone={
        <UIHeading3>
          <a href={formattedPhone.link}>{formattedPhone.number}</a>
        </UIHeading3>
      }
      builder={showBuilderName && <UIText3 color="text-secondary-default">{builder?.name}</UIText3>}
      qr={<PhoneLinkQRCode phoneLink={formattedPhone.link} onQRShow={onQRShowHandler} />}
    />
  );
};
